module.exports = __webpack_public_path__ + "img/01.f612c156.jpg";